import ScriptHelper from "base/ScriptHelper";
import $ from "jquery";

export function loadGoogleMap($element) {
    ScriptHelper.load_script("https://maps.googleapis.com/maps/api/js?key=AIzaSyAL04vokmvxsB_t9DKYLPcG3Pi_gNP28sE").then(() => {
        loadMap($element);
    });
}

function loadMap(element) {

    let $element = $(element);

    const mapOptions = {
        disableDefaultUI: false,
        center: new google.maps.LatLng(0, 0),
        gestureHandling: 'cooperative',
        backgroundColor: '#FFF',
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: true,
        fullscreenControl: false,
        zoom: 18,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    let $markers = $element.find('.js-marker');

    let map = new google.maps.Map($element[0], mapOptions);

    map.markers = [];

    console.log($markers);

    $markers.each((function () {
        initMarker($(this), map);
    }));

    centerMap(map);
}

export function initMarker($marker, map) {
    let infowindow;
    let latLng = {
        lat: parseFloat($marker.data('lat')),
        lng: parseFloat($marker.data('lng'))
    };

    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
    });

    marker.addListener('click', function () {
        if (infowindow) infowindow.close();

        let $content = (
            eotwJSXFactory('div', {className: "map-tooltip"}, [
                eotwJSXFactory('h2', {className: "heading heading--6"}, [$marker.data('name')]),
                eotwJSXFactory('p', null, [$marker.data('street_number'), ", ", $marker.data('street_name'), eotwJSXFactory('br'),
                    $marker.data('city'), ",", $marker.data('state'), eotwJSXFactory('br'),
                    $marker.data('post_code')]),
                eotwJSXFactory('a', {className: "map-tooltip__link", target: "_blank", rel: "noreferrer", href: 'https://www.google.com/maps/dir/?api=1&destination=' + $marker.data('address')}, ["Get directions"])
            ])
        );

        infowindow = new google.maps.InfoWindow({
            content: $content[0]
        });
        setTimeout(function () {
            $('.gm-style-iw-a').addClass('active');
        }, 100)

        infowindow.open(map, marker);
    });

    map.markers.push(marker);
}

export function centerMap(map) {
    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
    } else {
        map.fitBounds(bounds);
    }
}
